import React, { ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeZoomLevel } from "../../state/actions";
import { Slider } from "@material-ui/core";
import { getZoomLevel } from "../../state/selectors";
import { State } from "../../state/types";

interface Props {
  className?: string;
}

export default function Zoom({ className }: Props): ReactElement {
  const dispatch = useDispatch();
  const zoomLevel = useSelector(getZoomLevel());

  function valuetext(value) {
    return `${value} Level Zoom`;
  }

  return (
    <>
      <Slider
        className={className}
        value={zoomLevel}
        getAriaValueText={valuetext}
        aria-labelledby="discrete-slider-custom"
        step={1}
        max={5}
        min={1}
        onChange={(_, value) =>
          dispatch(changeZoomLevel(value as State["zoomLevel"]))
        }
      />
    </>
  );
}
